
<div class="settings-card">
	<div class="settings-card__header">
		<img src="../../../assets/images/Group 24.svg" alt="" />
		<div class="settings-card__header-headline">
			<h2>Bine ați venit!</h2>

		</div>
	</div>
</div>